import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-topbar" }
const _hoisted_2 = { class: "app-topbar__left" }
const _hoisted_3 = ["aria-label", "title"]
const _hoisted_4 = { class: "app-topbar__title" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "app-topbar__right" }
const _hoisted_7 = {
  key: 0,
  class: "app-topbar__owner"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api'
import UserMenu from '@/components/UserMenu.vue'
import type { AuthUser } from '@/store'

type Owner = { id: string, email: string, full_name?: string, organization?: string | null }


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTopbar',
  props: {
    collapsed: { type: Boolean },
    user: {}
  },
  emits: ["toggle", "logout"],
  setup(__props: any) {

const props = __props

const route = useRoute()
const router = useRouter()
const store = useStore()
const owners = ref<Owner[]>([])

const pageTitle = computed(() => typeof route.meta.title === 'string' ? route.meta.title : 'DocBrain')
const company = computed(() =>
  props.user?.organization?.trim() ||
  props.user?.receipt_profile?.business_name?.trim() ||
  props.user?.receipt_profile?.legal_name?.trim() ||
  ''
)
const canSwitchOwnerScope = computed(() => store.getters.canSwitchOwnerScope)
const selectedOwnerId = computed(() => store.getters.selectedOwnerId || props.user?.owner_id || props.user?.id || '')
const ownerLabel = (owner: Owner) =>
  [owner.full_name?.trim() || owner.email, owner.organization?.trim()].filter(Boolean).join(' · ')

const loadOwners = async () => {
  if (!canSwitchOwnerScope.value) {
    owners.value = []
    return
  }
  try {
    const response = await api.get('/users/switchable-owners')
    owners.value = Array.isArray(response.data) ? response.data : []
  } catch {
    owners.value = []
  }
}

const changeOwner = (event: Event) => {
  store.commit('setSelectedOwnerId', (event.target as HTMLSelectElement).value)
  router.go(0)
}

onMounted(loadOwners)
watch(canSwitchOwnerScope, loadOwners)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("button", {
        class: "app-topbar__mobile-menu",
        type: "button",
        "data-bs-toggle": "offcanvas",
        "data-bs-target": "#mobileNavigation",
        "aria-controls": "mobileNavigation",
        "aria-label": "Abrir menú",
        title: "Abrir menú"
      }, [
        _createElementVNode("i", {
          class: "fa-solid fa-bars",
          "aria-hidden": "true"
        })
      ], -1)),
      _createElementVNode("button", {
        class: "app-topbar__desktop-toggle",
        type: "button",
        "aria-label": _ctx.collapsed ? 'Expandir menú lateral' : 'Contraer menú lateral',
        title: _ctx.collapsed ? 'Expandir menú' : 'Contraer menú',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle')))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("i", {
          class: "fa-solid fa-bars-staggered",
          "aria-hidden": "true"
        }, null, -1)
      ]), 8, _hoisted_3),
      _createVNode(_component_router_link, {
        class: "app-topbar__mobile-brand",
        to: "/dashboard"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [
          _createTextVNode("DocBrain")
        ])),
        _: 1,
        __: [3]
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", null, _toDisplayString(pageTitle.value), 1),
        (company.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(company.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (canSwitchOwnerScope.value && owners.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { for: "owner-scope-select" }, "Empresa activa", -1)),
            _createElementVNode("select", {
              id: "owner-scope-select",
              class: "form-select form-select-sm",
              value: selectedOwnerId.value,
              onChange: changeOwner
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(owners.value, (owner) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: owner.id,
                  value: owner.id
                }, _toDisplayString(ownerLabel(owner)), 9, _hoisted_9))
              }), 128))
            ], 40, _hoisted_8)
          ]))
        : _createCommentVNode("", true),
      _createVNode(UserMenu, {
        user: _ctx.user,
        "show-label": true,
        onLogout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logout')))
      }, null, 8, ["user"])
    ])
  ]))
}
}

})